import { defaultTheme } from '../config/themes';

export default {
  publicKey: 'com_pk_test_BIaXTNNM_3UFolOa-LsEElFwXnZQIr4ilWMARWsdh-M',
  paymentMethods: {},
  stateLoading: false,

  methods: null,
  services: null,

  categories: null,
  selectedCategory: 'all',

  amount: null,
  public_key: null,
  description: null,

  // UI theme to use
  currentTheme: defaultTheme,

  step: 1,
  selectedService: null,
};
